import React, { Component } from "react";

import { Layout, Form, Input, Button } from "antd";
import { fire } from "../../services/firebase";

import s from "./Login.module.scss";

const { Header, Content, Footer } = Layout;

const onFinish = ({ email, password }) => {
	fire
		.auth()
		.signInWithEmailAndPassword(email, password)
		.then(res => {
			console.log('####: res', res);
		})
};

const onFinishFailed = (errorMsg) => {
	console.log("####: errorMsg", errorMsg);
};

class LoginPage extends Component {
	renderForm = () => {
		const layout = {
			labelCol: { span: 8 },
			wrapperCol: { span: 18 },
		};
		const tailLayout = {
			wrapperCol: { offset: 6, span: 18 },
		};
		return (
			<Form
				{...layout}
				name="basic"
				initialValues={{ renenber: true }}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
			>
				<Form.Item
					label="Username"
					name="email"
					rules={[{ required: true, message: "Please input your email!" }]}
				>
					<Input />
				</Form.Item>

				<Form.Item
					label="Password"
					name="password"
					rules={[{ required: true, message: "Please input your password!" }]}
				>
					<Input.Password />
				</Form.Item>
				<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
					<Button type="primary" htmlType="submit">
						Submit
					</Button>
				</Form.Item>
			</Form>
		);
	};

	render() {
		return (
			<Layout>
				<Content>
					<div className={s.root}>
						<div className={s.form_wrapper}>
							{ this.renderForm() }
						</div>
					</div>
				</Content>
			</Layout>
		);
	}
}

export default LoginPage;
